import type { AssetsPortalSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/assets';

type PortalPlaylist = { name?: string | null } | undefined;

/**
 * The title a portal is shown under. A portal can be created without its
 * own name, in which case its playlist's name stands in — so anything matching
 * or sorting on the title has to resolve it the same way the card does.
 */
export function getPortalDisplayTitle(
  portal: AssetsPortalSchemaWithIdNullable,
  playlist: PortalPlaylist,
): string {
  return portal.name || playlist?.name || 'Untitled portal';
}
